import React, { useEffect, useState } from "react";

export default function Reviews() {
  const reviews = [
    { name: "Michael Johnson (New York, USA)", text: "Extremely reliable and fast delivery. Highly impressed!", img: "/user1.jpg" },
    { name: "Emily Carter (Los Angeles, USA)", text: "Affordable pricing and excellent support!", img: "/user2.jpg" },
    { name: "David Thompson (Chicago, USA)", text: "SWIFTSHIP is now our company's preferred logistics partner.", img: "/user3.jpg" },
    { name: "Sarah Williams (Houston, USA)", text: "Smooth experience. Fast shipping every single time.", img: "/user4.jpg" },
    { name: "James Anderson (Miami, USA)", text: "Professional service and reliable tracking.", img: "/user5.jpg" },
    { name: "Olivia Martinez (Boston, USA)", text: "Great customer support! Very responsive.", img: "/user6.jpg" },
    { name: "Daniel Wilson (Seattle, USA)", text: "Fast customs clearance. Very satisfied.", img: "/user7.jpg" },
    { name: "Sophia Miller (San Diego, USA)", text: "Amazing logistics partner. Highly recommend!", img: "/user8.jpg" },
    { name: "Henry Clark (Denver, USA)", text: "Affordable and transparent pricing.", img: "/user9.jpg" },
    { name: "Ava Robinson (Phoenix, USA)", text: "100% trustworthy and professional!", img: "/user10.jpg" }
  ];

  const [index, setIndex] = useState(0);

  // Auto slide
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % reviews.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [reviews.length]);

  // Responsive cards per slide
  const getCardsPerView = () => {
    if (window.innerWidth < 768) return 1;
    if (window.innerWidth < 992) return 2;
    return 3;
  };

  const [cardsPerView, setCardsPerView] = useState(getCardsPerView());

  useEffect(() => {
    const resizeHandler = () => {
      setCardsPerView(getCardsPerView());
    };
    window.addEventListener("resize", resizeHandler);
    return () => window.removeEventListener("resize", resizeHandler);
  }, []);

  // Show slice of reviews based on index
  const visibleReviews = [];
  for (let i = 0; i < cardsPerView; i++) {
    visibleReviews.push(reviews[(index + i) % reviews.length]);
  }

  return (
    <>
      {/* ⭐ INLINE CSS */}
      <style>{`
        .reviews-wrapper {
          padding: 80px 0;
          background: #f5f8ff;
          overflow: hidden;
        }

        .review-card {
          background: white;
          border-radius: 18px;
          padding: 25px;
          text-align: center;
          border: 1px solid rgba(0,0,0,0.08);
          box-shadow: 0px 10px 30px rgba(0,0,0,0.1);
          transition: 0.3s ease;
        }

        .review-card:hover {
          transform: translateY(-10px);
          box-shadow: 0px 15px 40px rgba(0,0,0,0.15);
        }

        .review-img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          object-fit: cover;
          border: 3px solid #005eff40;
          margin-bottom: 12px;
        }

        .review-name {
          font-weight: 700;
          font-size: 17px;
        }

        .review-text {
          margin-top: 8px;
          font-size: 15px;
          color: #555;
        }

        .slider-row {
          display: flex;
          gap: 20px;
          justify-content: center;
          transition: 0.5s ease;
        }

        /* nav arrows */
        .slider-btn {
          background: #005eff;
          color: white;
          border: none;
          width: 45px;
          height: 45px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: 0.3s ease;
        }

        .slider-btn:hover {
          background: #0040d6;
        }
      `}</style>

      {/* ⭐ REVIEW SECTION */}
      <section className="reviews-wrapper">
        <div className="container text-center mb-4">
          <h2 className="fw-bold">Customer Reviews</h2>
          <p className="text-muted">What people in the USA say about SWIFTSHIP</p>
        </div>

        <div className="container d-flex justify-content-center align-items-center">

          {/* LEFT BUTTON */}
          <button 
            className="slider-btn me-3"
            onClick={() => setIndex((prev) => (prev - 1 + reviews.length) % reviews.length)}
          >
            <i className="bi bi-chevron-left"></i>
          </button>

          {/* SLIDER */}
          <div className="slider-row">
            {visibleReviews.map((r, i) => (
              <div className="review-card" style={{ width: "320px" }} key={i}>
                
                <img 
                  src={r.img} 
                  onError={(e) => e.target.style.display = "none"}
                  className="review-img"
                />

                <h5 className="review-name">{r.name}</h5>

                <p className="review-text">“{r.text}”</p>
              </div>
            ))}
          </div>

          {/* RIGHT BUTTON */}
          <button 
            className="slider-btn ms-3"
            onClick={() => setIndex((prev) => (prev + 1) % reviews.length)}
          >
            <i className="bi bi-chevron-right"></i>
          </button>

        </div>

      </section>
    </>
  );
}
